<template lang="pug">
  .crud
    #access(v-if="has_permission")
      modal-import(model="finished" :title="$t('front.import_modal', {model: $t('strings.finished')})")
      modal-select-contact(:project_id='project_id', :contacts_flag='contacts_flag', :selected_contacts='selected_contacts')
      .container-fluid
        vm-row.heading(vm-w="12")
          vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
            .list-title-cont
              .title-c
                h2 {{ $t('strings.finisheds') }}
                stage-indicator(color="#3DCB6F")
              span {{ $t('strings.description_view', {attribute: $t('strings.finisheds')}) }}
            div(style="display:none;")
              vm-button(type="default" icon="list")
              vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
            div
              //- vm-button(icon="plus" @click="addFinished") {{ $t('strings.add') }}
              vm-tooltip(:text="$t('strings.options')" delay=".5s")
                vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                  vm-button(type="border" icon="more-horizotnal" color="#afbbc6")

                  vm-dropdown-menu
                    vm-dropdown-item.d-flex.justify-content-between(@click="printReport")
                      vm-icon(icon="printer-outline")
                      slot &nbsp;{{ $t('strings.print') }}
        vm-row(vm-w="12")
          vm-col.card(vm-sm=12)
            vm-table(multiple v-model="selected"  max-height="350px" :data="finisheds")
              template(slot="header")
                .d-flex.justify-content-between
                  vm-input(ref="search" icon="search" size="small" :placeholder="searchPlaceholder" v-model="filters.where.param" @keyup.enter="applyFilter(filters)"  width="300px")
                  div
                    vm-tooltip(:text="$t('strings.filters')" delay=".5s")
                      vm-dropdown(ref='dropdown' vm-custom-content vm-trigger-click vm-trigger-outside-click)
                    vm-order-by(:sort-by-text="$t('strings.order_by')" placeholder="Ninguno" :data="columnsOrderBy" v-model="filters.orderBy" @change="changeOrderBy(filters)" size="small" width="200px" :serializer="item => $t('finisheds.'+ item)")
              template(slot="thead")
                vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('finisheds.' + column) }}
              template(slot-scope="{data}")
                vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                  vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                    slot(v-if="column == 'total' || column == 'amount'")  {{data[indextr][column] | currency }}
                    slot(v-if="column != 'status' && column != 'total' && column != 'amount' && column != 'currency' && column != 'customer'") {{ data[indextr][column] }}
                    slot(v-if="column == 'customer'") {{ data[indextr]['customer']['name'] }}
                    slot(v-if="column == 'currency'") {{ data[indextr]['currency_display'] }}
                    vm-status-indicator(v-if="column == 'status'" :pulse="data[indextr]['status'] !== 'Activo'" :color="colorStatus(data[indextr]['status'])") {{data[indextr]['status']}}
                  vm-td
                  vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                    vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")
                    vm-dropdown-menu(v-if="data[indextr]['stage'] === 4")
                      vm-dropdown-item.d-flex.justify-content-between(@click="openProjectGeneral(data[indextr])")
                        vm-icon(icon="eye-outline")
                        slot &nbsp;{{ $t('strings.view') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="saveRecord(data[indextr])")
                        vm-icon(icon="corner-up-left-outline")
                        slot &nbsp;{{ $t('strings.restore') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="addPayment(data[indextr])" v-if="payments_store_permission")
                        vm-icon(icon="eye-outline")
                        slot &nbsp;{{ $t('strings.view_payments') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="deleteFinishedConfirm(data[indextr])" v-if="$auth.check('Admin')")
                        vm-icon(icon="trash-2-outline")
                        slot &nbsp;{{ $t('strings.delete') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="selectContact(data[indextr])" v-if="canSelectContacts(data[indextr].customer_id)")
                        vm-icon(icon="people-outline")
                        slot &nbsp;{{ $t('strings.select_contacts') }}
                      //- More actions
            vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
            transition(name="enter")
              .total-records(v-if="total>0") Total: {{ total | currency }}
    #no-access(v-else)
      access-denied
</template>

<script>
import parseDeleteMany from '@/utils/parseDeleteMany'
import parseVuexObject from '@/utils/parseVuexObject'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Finisheds')

export default {
  name: 'Finisheds',
  components: {
    // ModalFinisheds: () => import('@/components/modals/ModalFinisheds.vue'),
    ModalImport: () => import('@/components/modals/ModalImport.vue'),
    StageIndicator: () => import('@/components/aditionals/StageIndicator.vue'),
    AccessDenied: () => import('@/components/aditionals/AccessDenied.vue'),
    ModalSelectContact: () => import('@/components/modals/ModalSelectContact.vue')
  },
  data: () => ({
    currentPage: 1,
    isModalAdd: true,
    payment: {},
    has_permission: true,
    payments_index_permission: true,
    payments_store_permission: true,
    newRecord: {},
    selected: [],
    contacts_flag: [],
    selected_contacts: [],
    columns: [
      'project_name',
      'customer',
      'location',
      'amount',
      'project_created_on',
      'quotation_start_date',
      'currency',
      'delivery_deadline',
      'completion_date'
    ],
    columnsOrderBy: [
      'completion_date'
    ],
    status: [
      // Agregar los estatus si maneja
      // {
      //   text: 'Pagado',
      //   value: 2,
      //   color: 'warning'
      // }
    ],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 60
      where: {
        project_name: '',
        param: ''
      },
      whereIn: {
        // Agrega las columnas que se filtraran con mas de una opcion ejemplo: status: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        // Agrega las columnas que se filtraran entre fechas: created_at: []
      },
      orderBy: ''
    },
    filtersClear: {}
  }),
  async created () {
    this.checkPermissionView('finisheds.index')
    this.filtersClear = parseVuexObject(this.filters)
    await this.getFinisheds(1)
    // await this.loadFinishedsCatalog()
  },
  methods: {
    ...mapActions([
      'deleteFinished',
      'deleteFinisheds',
      'loadFinisheds',
      'loadCatalog',
      'loadFinishedsCatalog',
      'actionFinished',
      'setModalImportVisible',
      'setModalVisible',
      'printReport',
      'applyFilter',
      'loadPayments',
      'clearFilter',
      'setModalContactVisible',
      'loadEmployees',
      'actionProjectRestore'
    ]),
    changeOrderBy (data) {
      if (data.orderBy) {
        let [field, order] = data.orderBy.split(',')
        if (order === 'dsc') {
          order = 'desc'
        }
        data.orderBy = `${field},${order}`
      }
      this.applyFilter(data)
    },
    saveRecord (finished) {
      this.$vm.dialog(
        {
          color: 'warning',
          title: this.$t('strings.restore_proyect'),
          text: this.$t('strings.restore_proyect_messages'),
          acceptText: this.$t('strings.project_to_inOrder'),
          accept: async () => { await this.actionProjectRestore(finished) }
        }
      )
    },
    checkPermissionView (permission) {
      this.employee_has_permission = this.$auth.user().view_payments === 1
      this.has_permission = this.$auth.user().view_permissions.findIndex(e => e.name === permission) > -1
      this.payments_index_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'payments.index') > -1
      this.payments_store_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'payments.store') > -1
    },
    colorStatus (code) {
      return this.status.find(e => e.value === parseInt(code))['color']
    },
    setFocusSearch () {
      this.$refs.search.$refs.vminput.focus()
    },
    async getPayments (project) {
      await this.loadPayments(project)
    },
    editShortcut () {
      if (this.selected.length === 0 || this.selected.length > 1) return
      const idx = this.finisheds.findIndex(u => u.id === this.selected[0].id)
      this.editFinished(this.selected[0], idx)
    },
    addPayment (item) {
      this.payment.id = item.id
      this.$router.push(`/finished/${this.payment.id}/payments`)
    },
    addFinished () {
      this.isModalAdd = true
      this.newRecord = {}
      this.setModalVisible(true)
    },
    openProjectGeneral (finished) {
      this.$router.push(`/projects/${finished.id}/general`)
    },
    async deleteFinishedConfirm (finished) {
      let t = this
      this.auxDeleteFinished = () => {
        t.deleteFinished(finished).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.finished'), attribute: this.$t(finished.id) }),
        accept: this.auxDeleteFinished
      })
    },
    async deleteFinishedsConfirm () {
      let t = this
      let finishedsMany = parseDeleteMany(this.selected, 'id')
      this.auxDeleteFinished = () => {
        t.deleteFinisheds(finishedsMany).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.finished'), attribute: finishedsMany.values }),
        accept: this.auxDeleteFinished
      })
    },
    async setActionFinished (record, action) {
      record.id && this.actionFinished({ id: record.id, action })
    },
    async getFinisheds (page) {
      let t = this
      this.loadFinisheds({ page }).then(data => t.getProps(t.$route.params.id))
    },
    getProps (index) {
      let finished = this.finisheds.filter(finished => finished.id === parseInt(index))[0]
      finished && this.editFinished(finished, index)
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    newObjectFuncModal (value) {
      //
    },
    newObjectFuncView (value) {
      //
    },
    handleChange (date) {
      // this.filters.betweenDates.created_at = date
    },
    hiddeDrop () {
      let [dropdownMenu] = this.$refs.dropdown.$children.filter((item) => {
        return item.hasOwnProperty('dropdownVisible')
      })
      dropdownMenu.dropdownVisible = false
    },
    async selectContact (quote) {
      this.project_id = quote.id
      this.contacts_flag = []
      this.selected_contacts = []
      let set1 = []
      let t = this
      await this.loadEmployees({ employer: quote.customer_id })
      setTimeout(() => {
        if (t.employees.length) {
          set1 = new Set(t.employees.map(e => e.id))
          t.contacts_flag = quote.contacts.map(e => !!set1.has(e.id))
          t.selected_contacts = quote.contacts.map(e => e.id)
          t.setModalContactVisible(true)
        } else {
          t.$vm.dialog({
            color: 'primary',
            title: t.$t('projects.contact'),
            text: 'No employees found'
          })
        }
      }, 1000)
    },
    canSelectContacts (id) {
      if (this.customer) {
        return this.customer.id === id
      }
      return true
    }
  },
  computed: {
    ...mapGetters([
      'finisheds',
      'pagination',
      'filterParams'
    ]),
    searchPlaceholder () {
      let t = this
      let concatColumns = Object.keys(this.filters.where).reduce((str, column, index) => {
        if (column !== 'param' && index < Object.keys(t.filters.where).length - 2) return (index > 0) ? `${str}, $\{t.$t('finisheds.' + column)}` : `${str} ${t.$t('finisheds.' + column)}`
        return str
      }, '')
      return this.$t('strings.search', { attribute: this.$t('strings.finished'), columns: concatColumns, column: this.$t('projects.' + Object.keys(this.filters.where)[Object.keys(t.filters.where).length - 2]) })
    },
    enabledDelete () {
      return this.selected.length > 0
    },
    total () {
      return this.selected.reduce((prev, cur) => prev + parseFloat(cur.total), 0).toFixed(2)
    }
  },
  watch: {
    filterParams (filter) {
      this.hiddeDrop()
      filter.length === 0 && (this.filters = parseVuexObject(this.filtersClear))
      this.selected = []
      this.currentPage = 1
      this.getFinisheds(this.currentPage)
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1)  {
    width: 100%;
  }
  .input-select-con{
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
.list-title-cont {
  display: flex;
  flex-direction: column;
  .title-c {
    display: flex;
    align-items: center;
  }
}
</style>
